import React from 'react';
import { cn } from '@/lib/utils';
import UserAvatar from '@/components/Profile/UserAvatar';
interface AuthorInfoProps {
  author: {
    name: string;
    avatar?: string;
    title?: string;
    bio?: string;
  };
  className?: string;
  showBio?: boolean;
  publishedDate?: string;
}
const AuthorInfo = ({
  author,
  className,
  showBio = false,
  publishedDate
}: AuthorInfoProps) => {
  if (!author) return null;
  return;
};
export default AuthorInfo;